export const getLocaleFromPath = (): string => {
    const defaultLocale = 'en_GB';
    
    try {
        if (typeof window === 'undefined') {
            return defaultLocale;
        }
        
        const pathSegments = window.location.pathname.split('/').filter(segment => segment.length > 0);
  
        if (pathSegments.length >= 2) {
            const locale = pathSegments[1];
            if (locale && /^[a-z]{2}_[A-Z]{2}$/i.test(locale)) {
                return locale;
            }
        }
    } catch (error) {
        console.warn('Error extracting locale from path, using default:', error);
    }
    
    return defaultLocale;
  }

  export const getMatchStateFromPeriod = (currentPeriod: number): {
    isHalfTime: boolean;
    isFullTime: boolean;
    isPenalties: boolean;
    isPreMatch: boolean;
    isEnded: boolean;
    isExtraTimeFirstHalf: boolean;
    isExtraTimeSecondHalf: boolean;
    isEndOfSecondHalf: boolean;
    isEndOfExtraTime: boolean;
    isHalfTimeOfExtraTime: boolean;
} => {
    return {
        isExtraTimeFirstHalf: currentPeriod === 3,
        isExtraTimeSecondHalf: currentPeriod === 4,
        isPenalties: currentPeriod === 5,
        isHalfTime: currentPeriod === 10,
        isEndOfSecondHalf: currentPeriod === 11,
        isHalfTimeOfExtraTime: currentPeriod === 12,
        isEndOfExtraTime: currentPeriod === 13,
        isFullTime: currentPeriod === 14,
        isEnded: currentPeriod === 14,
        isPreMatch: currentPeriod === 16,
    };
};

export const calculateMatchTimeFromPeriod = (currentPeriod: number, time_start: string | null): { minutes_played: number | null; seconds_played: number | null } => {
    try {
        if (!time_start) {
            return { minutes_played: null, seconds_played: null };
        }
        
        const now = new Date();
        const startTime = new Date(time_start);
        const elapsedMs = now.getTime() - startTime.getTime();
        const elapsedSeconds = Math.floor(elapsedMs / 1000);
        
        // Base time for each period (in seconds)
        const periodBaseTimes: { [key: number]: number } = {
            1: 0,      // First half - start from 0
            2: 45 * 60, // Second half - start from 45 minutes
            3: 90 * 60, // Extra time first half - start from 90 minutes
            4: 105 * 60, // Extra time second half - start from 105 minutes
            5: 120 * 60, // Penalty shootout - start from 120 minutes
            10: 45 * 60, // Half time - show 45 minutes
            11: 90 * 60, // End of second half - show 90 minutes
            12: 105 * 60, // Extra time half time - show 105 minutes
            13: 120 * 60, // End of extra time - show 120 minutes
            14: 90 * 60, // Full time - show 90 minutes
            16: 0 // Pre-match - show 0
        };
        
        const baseTime = periodBaseTimes[currentPeriod] || 0;
        const totalElapsedSeconds: { [key: number]: number } = {
            1: baseTime + elapsedSeconds,
            2: baseTime + elapsedSeconds,
            3: baseTime + elapsedSeconds,
            4: baseTime + elapsedSeconds,
            5: baseTime,
            10: baseTime,
            11: baseTime,
            12: baseTime,
            13: baseTime,
            14: baseTime,
            16: baseTime
        };

        const totalElapsedSecondsKey = totalElapsedSeconds[currentPeriod] || 0;
        
        const minutes_played = Math.floor(totalElapsedSecondsKey / 60);
        const seconds_played = totalElapsedSecondsKey % 60;
        
        return {
            minutes_played: Math.max(0, minutes_played),
            seconds_played: Math.max(0, seconds_played)
        };
        
    } catch (error) {
        console.error('Error calculating match time from period:', error);
        return { minutes_played: null, seconds_played: null };
    }
};

export const processMatchClockData = (matchClockData: any): any => {
    if (!matchClockData || !matchClockData.current_period) {
        return matchClockData;
    }
    
    const { minutes_played, seconds_played } = calculateMatchTimeFromPeriod(
        matchClockData.current_period,
        matchClockData.time_start
    );
    
    const matchState = getMatchStateFromPeriod(matchClockData.current_period);
    
    const isRunning = !(matchClockData.current_period === 10 || 
                       matchClockData.current_period === 14 || 
                       matchClockData.current_period === 11 || 
                       matchClockData.current_period === 13 ||
                       matchClockData.current_period === 12 ||
                       matchClockData.current_period === 16);
    
    return {
        ...matchClockData,
        minutes_played,
        seconds_played,
        is_running: isRunning,
        ...matchState
    };
};